export function canModifyTruckCheckTasks(status: string | null | undefined): boolean {
  return status === "in_progress";
}
